import { B2BContent } from "../../domain/entities/B2BContent"
import { B2BRepository } from "../../domain/repositories/b2bRepository"
import { B2BContentModel } from "../models/B2BContentModel"
import { B2BService } from "../services/B2BService"

export class B2BRepositoryImpl implements B2BRepository {
	private _b2bService
	constructor({ B2BService }: { B2BService: B2BService }) {
		this._b2bService = B2BService
	}

	updateB2BContent(content: B2BContent[]): Promise<void> {
		return this._b2bService.updateB2BTexts(
			content.map(c => B2BContentModel.fromDomain({ ...c, locale: c.locale! }))
		)
	}

	updateB2BImage(imageName: "wideImage" | "headerImage", images: { image: File; locale: string }[]): Promise<string> {
		return this._b2bService.updateB2BImage(imageName, images)
	}

	async getB2BContent(): Promise<B2BContent[]> {
		const content = await this._b2bService.getB2BContent()
		return content.map(c => c.toDomain())
	}
}
